import { loan_application_api } from '@axo/shared/data-access/api';
import { useAPI } from '@axo/shared/data-access/provider';
import { useQuery } from 'react-query';
import { applicationKeys } from '../../cache-keys/applicationKeys';

export function useLoanApplicationDependencies(applicationID?: string) {
  const api = useAPI();
  const queryKey = applicationKeys.dependencies(applicationID);

  return useQuery({
    queryKey,
    queryFn: () =>
      loan_application_api.getLoanApplicationDependencies(api)(
        applicationID ?? ''
      ),
    enabled: api.token.length > 0 && Boolean(applicationID),
  });
}
